var _g, _g2, _g3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencyAlarmGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_114_8984)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.9826,
    cy: 50.4829,
    r: 42.2165,
    fill: "#969696",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_114_8984)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.9829,
    cy: 50.4827,
    r: 33.4638,
    fill: "url(#paint0_linear_114_8984)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_114_8984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5602 50.5257C85.5602 68.4939 70.9942 83.06 53.026 83.06C35.0578 83.06 20.4917 68.4939 20.4917 50.5257C20.4917 32.5575 35.0578 17.9915 53.026 17.9915C70.9942 17.9915 85.5602 32.5575 85.5602 50.5257ZM24.8556 50.5257C24.8556 66.0838 37.4679 78.6961 53.026 78.6961C68.5841 78.6961 81.1964 66.0838 81.1964 50.5257C81.1964 34.9677 68.5841 22.3553 53.026 22.3553C37.4679 22.3553 24.8556 34.9677 24.8556 50.5257Z",
    fill: "url(#paint1_angular_114_8984)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3136 43.3052C58.2496 43.3052 62.2509 47.3065 62.2509 52.2425V58.7704C62.2509 59.0082 62.1565 59.2362 61.9883 59.4043C61.8202 59.5725 61.5922 59.6669 61.3544 59.6669H45.2728C45.035 59.6669 44.807 59.5725 44.6389 59.4043C44.4707 59.2362 44.3763 59.0082 44.3763 58.7704V52.2425C44.3763 47.3065 48.3776 43.3052 53.3136 43.3052ZM52.5291 38.3743H54.0981C54.1575 38.3743 54.2145 38.3979 54.2566 38.4399C54.2986 38.4819 54.3222 38.539 54.3222 38.5984V41.288C54.3222 41.3474 54.2986 41.4045 54.2566 41.4465C54.2145 41.4885 54.1575 41.5121 54.0981 41.5121H52.5291C52.4697 41.5121 52.4127 41.4885 52.3707 41.4465C52.3286 41.4045 52.305 41.3474 52.305 41.288V38.5984C52.305 38.539 52.3286 38.4819 52.3707 38.4399C52.4127 38.3979 52.4697 38.3743 52.5291 38.3743ZM43.935 41.8388C43.9558 41.818 43.9806 41.8014 44.0078 41.7902C44.035 41.7789 44.0641 41.7731 44.0936 41.7731C44.1231 41.7731 44.1522 41.7789 44.1794 41.7902C44.2066 41.8014 44.2314 41.818 44.2522 41.8388L46.1539 43.7406C46.1959 43.7826 46.2195 43.8396 46.2195 43.899C46.2195 43.9584 46.1959 44.0154 46.1539 44.0574L45.0445 45.1669C45.0025 45.2089 44.9455 45.2325 44.8861 45.2325C44.8266 45.2325 44.7696 45.2089 44.7276 45.1669L42.8258 43.2651C42.7838 43.2231 42.7603 43.1661 42.7603 43.1067C42.7603 43.0473 42.7838 42.9903 42.8258 42.9483L43.9353 41.8388H43.935ZM62.695 41.8388L63.8044 42.9483C63.8464 42.9903 63.8699 43.0472 63.8699 43.1066C63.8699 43.1659 63.8464 43.2228 63.8044 43.2649L61.9027 45.1672C61.8819 45.188 61.8571 45.2046 61.8299 45.2158C61.8027 45.2271 61.7735 45.2329 61.7441 45.2329C61.7146 45.2329 61.6855 45.2271 61.6583 45.2158C61.6311 45.2046 61.6063 45.188 61.5855 45.1672L60.4761 44.0577C60.4552 44.0369 60.4387 44.0122 60.4274 43.985C60.4161 43.9578 60.4103 43.9286 60.4103 43.8992C60.4103 43.8697 60.4161 43.8405 60.4274 43.8133C60.4387 43.7861 60.4552 43.7614 60.4761 43.7406L62.3781 41.8388C62.4201 41.7968 62.4771 41.7732 62.5365 41.7732C62.596 41.7732 62.653 41.7968 62.695 41.8388ZM44.3483 61.46H62.2789C62.5167 61.46 62.7447 61.5544 62.9129 61.7226C63.081 61.8907 63.1755 62.1187 63.1755 62.3565V63.0289C63.1755 63.0884 63.1519 63.1454 63.1098 63.1874C63.0678 63.2294 63.0108 63.2531 62.9513 63.2531H43.6759C43.6164 63.2531 43.5594 63.2294 43.5174 63.1874C43.4754 63.1454 43.4517 63.0884 43.4517 63.0289V62.3565C43.4517 62.1187 43.5462 61.8907 43.7143 61.7226C43.8825 61.5544 44.1105 61.46 44.3483 61.46ZM48.4947 52.5787V59.6669H50.2878V52.5787H48.4947Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_114_8984",
    x: 9.20254,
    y: 8.26636,
    width: 87.5603,
    height: 87.5603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.56358
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.781788
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_114_8984",
    x: 18.2796,
    y: 17.0189,
    width: 69.4065,
    height: 69.4064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2394
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.619701
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_114_8984",
    x: 19.2523,
    y: 17.9915,
    width: 67.5472,
    height: 67.5474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2394
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.619701
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_114_8984",
    x: 0.62963,
    y: 0,
    width: 104.741,
    height: 104.741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.87037
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.935185
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_114_8984"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_114_8984",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_114_8984",
    x1: 52.9829,
    y1: 17.0189,
    x2: 52.9829,
    y2: 83.9466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A19E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69A9A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_114_8984",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.026 19.5863) rotate(90) scale(63.4737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD0000",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B70000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_114_8984",
    x1: 53,
    y1: 0,
    x2: 53,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A19E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A69A9A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyAlarmGrey);
export default __webpack_public_path__ + "static/media/emergency-alarm-grey.08c15724fcae0098879b4747818ad717.svg";
export { ForwardRef as ReactComponent };